import React  from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';

import Phi from './Phi/Phi';
import Role from './Phi/PhiRole';

import App from './Containers/AppContainer';
import Actions from './Actions/Creators';
import UnAuthenticatedScreen from './Containers/UnAuthenticatedScreen';



class Routes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isMagicLink: false
        }
    }

    componentWillMount() {
        if(this.props.location.pathname.match('/magic-link')) {
            this.setState({isMagicLink: true})
            this.props.loginUsingMagicLink(this.props.location.pathname.match('/magic-link/(.*)')[1])   
        }else {
            this.isAuthenticated()
        }
    }
      
    componentWillReceiveProps(newProps) {
        if (!!newProps.isAuthenticated && ((this.props.isAuthenticated !== newProps.isAuthenticated) || (newProps.location.pathname === '/login' || newProps.location.pathname === '/'))) {
            this.isAuthenticated()
        }
    }

    render() {
        return (
        <section className="root-container">
            {this.isAuthenticated() ?
                <Route path="/" component={App} />

                :

                <Route path="/" component={UnAuthenticatedScreen} />
            }
        </section>);
    }



    isAuthenticated() {
        let isAuthenticated = Phi.User.isAuthenticated();

        if(!Boolean(isAuthenticated)) {
            let authStatus = false;
            
            const cookies = this.props.cookies;

            let token = cookies.get('token');
            if (Boolean(token) && Boolean(token.jwt)) {
                let roles = cookies.get('roles');
                let profile = cookies.get('profile');
                let custom = cookies.get('custom');

                if (Boolean(roles) && Boolean(profile)) {
                    Phi.Storage.setItem('roles', JSON.stringify(roles));
                    roles = roles.map((a) => new Role(a));
                    Phi.User.userRoles = roles;

                    Phi.Storage.setItem('profile', JSON.stringify(profile));
                    Phi.User.userProfile = profile;

                    Phi.Storage.setItem('custom', JSON.stringify(custom));

                    Phi.setSession(token);

                    this.props.loginResponse({ ok: true, error: false, message: 'Already Logged In' });

                    authStatus = true;
                }
            }
    
            return authStatus;
        }

        else {
            return true;
        }
    }

}

const mapStateToProps = (state, ownProps) => ({
    isAuthenticated: state.auth.isAuthenticated,
    message: state.auth.message,
    isLoading: state.auth.isLoading
});


const mapDispatchToProps = (dispatch) => ({
    loginResponse: (response) => { dispatch(Actions.loginResponse(response)) },
    loginUsingMagicLink: (magicLink) => dispatch(Actions.loginUsingMagicLink(magicLink))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withCookies(Routes)))


// WEBPACK FOOTER //
// ./src/routes.js